// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2UXJO","fileBtn":"File_fileBtn__3qIew","closeBtn":"File_closeBtn__1NfZJ","fileSelected":"File_fileSelected__2lZ3L","disabled":"File_disabled__2Lurd"};